module.exports = __webpack_public_path__ + "static/media/folder_01_A.3860e978.png";